/* =============================================================
   Service Terms — United Dream Mongolia
   Per-visa service inclusions + general terms
   ============================================================= */

export interface ServiceTermsEntry {
  visaType: string;
  services: string[];
}

/** Keyed by exact visaKey (e.g. "usa-travel", "usa-study") */
export const SERVICE_TERMS_BY_VISA: Record<string, ServiceTermsEntry> = {
  "usa-travel": {
    visaType: "АНУ аяллын виз (B1/B2) — 10 жил",
    services: [
      "Иж бүрэн дэлгэрэнгүй зөвлөгөө",
      "Нөхцөл байдлын судалгаа",
      "Элчингийн цаг авах",
      "DS-160 маягт бөглөлт",
      "Ярилцлаганд бэлдэх (Mock Interview)",
      "Баталгаат хаяг",
      "Орчуулга (байгууллага хариуцна)",
      "Аяллын төлөвлөгөө",
      "Материал бүрдүүлэлтийн зөвлөгөө",
      "Таны онцлогоос шалтгаалан нэмэлт дэмжлэл",
    ],
  },
  "usa-study": {
    visaType: "АНУ сургалтын виз (F-1/F-2)",
    services: [
      "Иж бүрэн дэлгэрэнгүй зөвлөгөө",
      "Нөхцөл байдлын судалгаа",
      "Сургуулийн I-20 урилга (маш чухал)",
      "Сургуулийн судалгаа",
      "Acceptance Letter авах дэмжлэл",
      "DS-160 маягт бөглөлт",
      "SEVIS төлөлтийн дэмжлэл",
      "Орчуулга (байгууллага хариуцна)",
      "Ярилцлаганд бэлдэх (Mock Interview)",
      "Материал бүрдүүлэлтийн зөвлөгөө",
      "Таны онцлогоос шалтгаалан нэмэлт дэмжлэл",
    ],
  },
  "australia-travel": {
    visaType: "Австрали аяллын виз (Subclass 600)",
    services: [
      "Иж бүрэн дэлгэрэнгүй зөвлөгөө",
      "Нөхцөл байдлын судалгаа",
      "Элчинд бичэх албан ёсны захидал",
      "Онлайн анкет бөглөлт",
      "Материал бүрдүүлэлтийн зөвлөгөө",
      "Материалын тайлбар (маш чухал)",
      "Баталгаат хаяг",
      "Орчуулга (байгууллага хариуцна)",
      "Аяллын төлөвлөгөө",
      "Таны онцлогоос шалтгаалан нэмэлт дэмжлэл",
    ],
  },
  "australia-study": {
    visaType: "Австрали сургалтын виз",
    services: [
      "Иж бүрэн дэлгэрэнгүй зөвлөгөө",
      "Нөхцөл байдлын судалгаа",
      "Сургуулийн элсэлтийн дэмжлэл",
      "CoE (Confirmation of Enrolment) авах",
      "Онлайн анкет бөглөлт",
      "Материал бүрдүүлэлтийн зөвлөгөө",
      "Материалын тайлбар (маш чухал)",
      "Орчуулга (байгууллага хариуцна)",
      "Таны онцлогоос шалтгаалан нэмэлт дэмжлэл",
    ],
  },
  "canada-travel": {
    visaType: "Канад аяллын виз",
    services: [
      "Иж бүрэн дэлгэрэнгүй зөвлөгөө",
      "Нөхцөл байдлын судалгаа",
      "Элчинд бичэх албан ёсны захидал",
      "IMM анкет бөглөлт, GCKEY профайл үүсгэлт",
      "Материал бүрдүүлэлтийн зөвлөгөө",
      "Материалын тайлбар (маш чухал)",
      "Баталгаат хаяг",
      "Орчуулга (байгууллага хариуцна)",
      "Аяллын төлөвлөгөө",
      "Таны онцлогоос шалтгаалан нэмэлт дэмжлэл",
    ],
  },
  "schengen-travel": {
    visaType: "Шенгений аяллын виз",
    services: [
      "Иж бүрэн дэлгэрэнгүй зөвлөгөө",
      "Нөхцөл байдлын судалгаа",
      "Элчинд бичэх албан ёсны захидал",
      "Анкет бөглөлт",
      "Элчингийн цаг авах",
      "Материал бүрдүүлэлтийн зөвлөгөө",
      "Материалын тайлбар (маш чухал)",
      "Баталгаат хаяг",
      "Орчуулга (байгууллага хариуцна)",
      "Аяллын төлөвлөгөө",
      "Таны онцлогоос шалтгаалан нэмэлт дэмжлэл",
    ],
  },
  "ireland-study": {
    visaType: "Ирланд сургуулийн виз",
    services: [
      "Гэрээт сургуульд элсүүлэх",
      "Acceptance Letter (бүх баримттай)",
      "Виз мэдүүлэх бүх үйлчилгээ",
      "AVATS маягт бөглөлт",
      "Орчуулга (байгууллага хариуцна)",
      "VFS Global цаг авах",
      "Материалын тайлбар",
      "Элчинд бичих захидал",
      "Татгалзсан нөхцөлд давж заалдах (үнэгүй)",
      "Таны онцлогоос шалтгаалан нэмэлт дэмжлэл",
    ],
  },
  "czech-work": {
    visaType: "Чехийн ажлын виз",
    services: [
      "Хөдөлмөрийн гэрээ, элчингийн цагийн хамт",
      "Шаардлагатай материал бүрдүүлэлт",
      "Элчингийн ярилцлаганд бэлдэх",
      "Орчуулга (байгууллага хариуцна)",
      "Тосох үйлчилгээ",
    ],
  },
};

export const GENERAL_TERMS = [
  "Дээр заасан үйлчилгээг үзүүлнэ.",
  "Үйлчилгээний төлбөр төлснөөс хойш үйлчилгээ баталгаажна.",
  "Төлбөр төлснөөс хойш ажлын 5 хоногын дотор partner@untdream.com руу хандсанаар үйлчилгээг цуцалж болох бөгөөд төлбөрийн 50%-ийг буцааж олгоно. Үлдсэн 50%-ийг байгууллага платформ ашигласны төлбөрт суутгана.",
  "Визний эцсийн хариуг зөвхөн элчин сайдын яам шийдэх бөгөөд виз гарна гэсэн баталгаа өгөхгүй. Мөн визний хариу бодит хугацаанаас илүү хурдан эсвэл удаж болно.",
  "Виз татгалзсан нөхцөлд үнэ төлбөргүй дахин мэдүүлэх болон улсаа сольж мэдүүлж болно.",
  "Үйлчлүүлэгч 500,000₮ нэмж төлөн аль нэг улсын визийг гаран гартал мэдүүлж болно. Энэ нөхцөлд визний хураамж болон орчуулгын зардлыг үйлчлүүлэгч өөрөө хариуцна.",
  "Визний хураамжийг үйлчлүүлэгч өөрөө хариуцна.",
  "Асуулт, хүсэлтийн хувьд partner@untdream.com хаягаар холбогдоход 24 цагийн дотор хариу өгнө.",
  "Маргаан гарсан нөхцөлд 2 тал эв зүйгээр шийдэх бөгөөд хэрэв шийдэж чадахгүй бол Монгол улсын иргэний хэргийн шүүхээр асуудлыг шийдүүлнэ.",
];
